export const SPACING = [
  'spacing-4-xs',
  'spacing-3-xs',
  'spacing-2-xs',
  'spacing-xs',
  'spacing-s',
  'spacing-m',
  'spacing-l',
  'spacing-xl',
];

export const ALIGN = {
  left: 'left',
  center: 'center',
  right: 'right',
  spaceBetween: 'space-between',
};

export const VERTICAL_ALIGN = {
  stretch: 'stretch',
  start: 'start',
  center: 'center',
  end: 'end',
};
